<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
  <app-buttons
    (save)="submit()"
    (close)="closePanel()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>

  <div class="editor-registro">
    <div class="divForm">
      <form [formGroup]="editPriceTypeForm" (ngSubmit)="submit()">
        <div class="form-group">
          <mat-form-field appearance="outline">
            <mat-label>{{ translation?.TipoPrecio || "Tipo de precio" }}</mat-label>
            <input
              matInput
              formControlName="TipoPrecio"
              maxlength="50"
              (input)="onInputForbiddenSequences($event, 'TipoPrecio')"
            />
            <mat-error *ngIf="validateFields('TipoPrecio')">
              {{ getErrorMessage("TipoPrecio") }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>{{
              translation?.EtiquetaTrabajo || "Etiqueta de trabajo"
            }}</mat-label>
            <input
              matInput
              formControlName="EtiquetaTrabajo"
              maxlength="50"
              (input)="onInputForbiddenSequences($event, 'EtiquetaTrabajo')"
            />
            <mat-error *ngIf="validateFields('EtiquetaTrabajo')">
              {{ getErrorMessage("EtiquetaTrabajo") }}
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
</div>
